export default "__VITE_ASSET__CjVC858f__"